import NeverKnowinglyUndersoldComponent from './NeverKnowinglyUndersoldComponent';
export default class WhereDidYouPurchaseQuestion extends NeverKnowinglyUndersoldComponent {

  constructor(resetWherePurchasedQuestionFn) {
    super(document.querySelector('#where-jl-purchased--question'));
    this.reset = resetWherePurchasedQuestionFn;
  }

  render(state) {
    if (state.alreadyPurchased) {
      this.show();
      this.enableChildInputs();
    } else {
      this.hide();
      this.disableChildInputs();
      this.reset();
    }
  }
}
